import React from "react";
import Details from "../../User/Details";

export default({competitionId, path}) => {

  return (
        <Details id={competitionId} path={path}/>
  );
};
